import { useTranslation } from 'react-i18next';
import { TableV2 } from '@anytag/shared-atoms';
import { TableData } from '@anytag/shared-types';
import { WarningModal } from '@anytag/shared-molecules';
import { Payment, PaymentRequestStatus } from '@anytag/graphql';
import { usePaymentsTable, useUpdatePayment } from './hooks';

export type PaymentsListProps = TableData<Payment>;

export const PaymentsList = ({ loading, data = [] }: PaymentsListProps) => {
  const { t } = useTranslation();
  const { updating, selectedPayment, setSelectedPayment, updatePaymentStatus } = useUpdatePayment();
  const { columns } = usePaymentsTable({ onSelectedPayment: setSelectedPayment });

  const handleCloseModal = () => {
    setSelectedPayment(null);
  };

  return (
    <>
      <TableV2 loading={loading} data={data} columns={columns} noTopBorderRadius />

      <WarningModal
        open={!!selectedPayment}
        onClose={handleCloseModal}
        title={`${t(
          selectedPayment?.status === PaymentRequestStatus.PAID
            ? 'Dialog.Are you sure you want to pay to'
            : 'Dialog.Are you sure you want to change the status to Failed for',
          { name: selectedPayment?.name }
        )}?`}
        footer={{
          cancelButton: { title: t('Button.Cancel'), onClick: handleCloseModal },
          submitButton: {
            loading: updating,
            onClick: updatePaymentStatus,
            title: t(selectedPayment?.status === PaymentRequestStatus.PAID ? 'Button.Pay' : 'Button.Update')
          }
        }}
      />
    </>
  );
};
